import { gql } from '@apollo/client';

const INSTANT_REPORT_FRAGMENT = gql`
  fragment InstantReportFragment on Report {
    id
    type
    start
    stop
    status
    isArtifactReport
    reportId
    createdAt
    physicianInterpretation
    technicianComments
    hasSignature
    lastModified
    formatVersion
    aiFormatVersion
    inbox {
      date
      priority
      isReviewed
      isRead
    }
    event {
      id
      friendlyId
      hasClinicData
      comments
    }
    study {
      id
      friendlyId
      externalSource {
        provider
        externalId
      }
      start
      timezone
      studyTimeOffset
      studyType
      isBiofluxDirect
      info {
        interprettingPhysician {
          id
          firstName
          lastName
        }
        patient {
          firstName
          lastName
          patientId
        }
      }
      facility {
        id
        name
        timezone
        contact {
          country
        }
      }
    }
    createdBy {
      id
    }
    profile
    timeMonitored
  }
`;

export default INSTANT_REPORT_FRAGMENT;
